// src/components/DeleteSFTPIntegration.tsx

import React from 'react';
import { Dialog } from '@headlessui/react';
import { Button } from '@/components/ui/button';

interface DeleteSFTPIntegrationProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

const DeleteSFTPIntegration: React.FC<DeleteSFTPIntegrationProps> = ({ open, onClose, onDelete }) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <Dialog.Overlay className="fixed inset-0 bg-black opacity-30" />
      <div className="fixed inset-0 flex items-center justify-center">
        <Dialog.Panel className="w-full max-w-sm rounded bg-white p-6">
          <Dialog.Title className="text-lg font-semibold">Confirm Deletion</Dialog.Title>
          <Dialog.Description className="mt-2">
            Are you sure you want to delete this integration? This action cannot be undone.
          </Dialog.Description>
          <div className="mt-4 flex justify-end">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button variant="destructive" onClick={onDelete} className="ml-2">
              Delete
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default DeleteSFTPIntegration;
